import { render } from "./TableHeadRow.vue?vue&type=template&id=5057f3ae&scoped=true"
import script from "./TableHeadRow.vue?vue&type=script&lang=ts"
export * from "./TableHeadRow.vue?vue&type=script&lang=ts"

import "./TableHeadRow.vue?vue&type=style&index=0&id=5057f3ae&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5057f3ae"

export default script